export const forBusiness_realEstate_faster = [
	{
		icon: '🔹',
		subtitle: 'fasterData_subtitle1',
	},
	{
		icon: '🔹',
		subtitle: 'fasterData_subtitle2',
	},
];
